// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"6be8b271","172":"e4fdf3b8","246":"a5a52c2d","300":"8a81a506","330":"7cf8e3ad","506":"285d1413","576":"fb1f65c4","661":"8517432e","804":"9a4dc756","892":"e0f4f122","908":"4e32d820","971":"165c819a","987":"dbb85d7e"}[chunkId] + ".chunk.js";
};